import { useEffect } from "react";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { HiOutlineChevronDown } from "react-icons/hi2";

import Button from "@/components/atoms/Button";

export type HasMoreDataButtonProps = {
  onOpenChange: (isOpen: boolean) => void;
  children?: React.ReactNode;
};

const HasMoreDataButton = ({ onOpenChange, children }: HasMoreDataButtonProps) => {
  return (
    <>
      <Popover className="group">
        {({ open }) => {
          useEffect(() => {
            onOpenChange(open);
          }, [open]);

          return (
            <>
              <PopoverButton as={"div"} className={"flex items-center"}>
                <Button
                  leadingIcon={<HiOutlineChevronDown className="size-4 group-data-[open]:rotate-180" />}
                  className="!p-0.5"
                  color="natural"
                  variants={"outline"}
                  size="2xs"
                />
              </PopoverButton>

              <PopoverPanel
                anchor={{ to: "bottom end", gap: "2px", offset: "2px" }}
                className="flex flex-col rounded-lg border border-secondary bg-white py-4 shadow-md"
              >
                {open && children}
              </PopoverPanel>
            </>
          );
        }}
      </Popover>
    </>
  );
};

export default HasMoreDataButton;
